import { useTranslation } from 'react-i18next';
import { smallestFontSize, smallestMargin } from '_utils/sizes';
import { SelectorChip } from 'Components';

const BookingSharingTag = ({ type }: { type: 'request' | 'availability' }) => {
    const { t } = useTranslation();
    return (
        <SelectorChip
            variant={type === 'request' ? 'MustardBlack' : 'lightPrimary'}
            title={t(`bookingSharing:${type}`)}
            containerStyle={{
                alignSelf: 'flex-start',
                paddingLeft: smallestMargin,
                paddingRight: smallestMargin,
                paddingTop: smallestMargin,
                paddingBottom: smallestMargin,
            }}
            titleStyle={{ fontSize: smallestFontSize }}
        />
    );
};

export default BookingSharingTag;
